var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Installations, { InstallProperty } from '../apis/installations';
var mountTypes = [
    'Not Selected',
    'Side-Mount on Fence or Wall',
    'Top-Mount on Post or Pole',
    'Roof-Edge, Peak or Gable Mount',
    'Chimney Mount',
    'Tempest setup Only'
];
export function activateServiceEvent(serviceEvent, showProgress) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    showProgress('Saving Contact');
                    return [4 /*yield*/, saveContact(serviceEvent)];
                case 1:
                    _a.sent();
                    showProgress('Saving Schedule');
                    return [4 /*yield*/, saveSchedule(serviceEvent)];
                case 2:
                    _a.sent();
                    showProgress('Saving Properties');
                    return [4 /*yield*/, saveProperties(serviceEvent)];
                case 3:
                    _a.sent();
                    // activate service event
                    showProgress('Activating');
                    console.log('Activate');
                    return [4 /*yield*/, Installations.activateServiceEvent(serviceEvent.serviceEventId)];
                case 4:
                    _a.sent();
                    showProgress('Complete');
                    return [2 /*return*/];
            }
        });
    });
}
function saveContact(serviceEvent) {
    // save contact info
    var contact = {
        firstName: serviceEvent.contact.firstName,
        lastName: serviceEvent.contact.lastName,
        address: serviceEvent.location.street,
        address2: serviceEvent.location.street2,
        city: serviceEvent.location.city,
        state: serviceEvent.location.state,
        zipCode: serviceEvent.location.zip,
        company: serviceEvent.location.company,
        email: serviceEvent.contact.email,
        phoneNumber: serviceEvent.contact.phone,
        serviceEventId: serviceEvent.serviceEventId
    };
    console.log('Save contact');
    return Installations.saveContact(contact);
}
function saveSchedule(serviceEvent) {
    // save schedule info
    var schedule = {
        serviceEventId: serviceEvent.serviceEventId,
        scheduleDate: serviceEvent.schedule.scheduleDate,
        availability: serviceEvent.schedule.availability,
        scheduleNotes: serviceEvent.schedule.scheduleNotes
    };
    console.log('Save schedule');
    return Installations.setSchedule(schedule);
}
function saveProperties(serviceEvent) {
    // add properties (home color, apartment/condo, etc)
    var properties = [];
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "aptCondo", serviceEvent.location.apartment === "Yes" ? "Apartment / Condo" : "Single Family"));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "numOfFloors", serviceEvent.location.floors));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "ownProperty", serviceEvent.location.own));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "securityGate", serviceEvent.location.securityGate === "Yes" ? "Security Gate" : ""));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "havePets", serviceEvent.location.pets));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "homeColor", serviceEvent.location.color));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "description", mountTypes[serviceEvent.location.mount]));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "contactNotes", serviceEvent.contact.instructions));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "specialInst", serviceEvent.location.directions));
    properties.push(new InstallProperty(serviceEvent.serviceEventId, "textReminder", serviceEvent.contact.textReminder));
    return Installations.updateServiceEventProperties(serviceEvent.serviceEventId, properties);
}
